import { Divider, Skeleton, Stack } from '@mui/material';
import { Nullable } from 'global';
import { VendorOpportunity } from 'modules/vendorOpportunity';
import { QuoteCalcViewModel } from 'modules/quote';
import { DealBuilderEntity, DealBuilderQuote } from '../../../../api';
import { DealBuilderEquipmentSource } from '../../../../types';
import { DealDetailsHeader } from './DealDetailsHeader';
import { SummaryCards } from './SummaryCards';
import { InsightsCards } from './InsightsCards';
import { DocumentsSection } from './DocumentsSection';
import { EquipmentItemsSection } from './EquipmentItemsSection';
import { TradeInSection } from './TradeInSection';
import { AdditionalChargesSection } from './AdditionalChargesSection';
import { Document } from '@trnsact/trnsact-shared-types';

interface Props {
  vo: VendorOpportunity;
  activeEntity: Nullable<DealBuilderEntity>;
  quote: Nullable<DealBuilderQuote>;
  loading: boolean;
  priceCalc: Nullable<QuoteCalcViewModel>;
  equipmentData: Nullable<DealBuilderEquipmentSource[]>;
  invoiceDoc: Nullable<Document>;
  refetchDocs: VoidFunction;
}

export const DealTab = ({
  vo,
  activeEntity,
  quote,
  loading,
  priceCalc,
  equipmentData,
  invoiceDoc,
  refetchDocs,
}: Props) => {
  if (loading) {
    return (
      <Stack gap={2} pt={2}>
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 1 }} />
      </Stack>
    );
  }

  return (
    <Stack gap={1} pt={2}>
      <DealDetailsHeader activeEntity={activeEntity} quote={quote} />
      {activeEntity && (
        <>
          <SummaryCards quote={quote} priceCalc={priceCalc} />
          <InsightsCards priceCalc={priceCalc} />
        </>
      )}
      <Divider />
      <DocumentsSection
        vendorOpportunityId={vo?.vendorOpportunityId ?? ''}
        dynamicsVendorOpportunityId={vo?.dynamicsVendorOpportunityId ?? ''}
        invoiceDoc={invoiceDoc}
        refetchDocs={refetchDocs}
      />
      <Divider />
      <EquipmentItemsSection quote={quote} priceCalc={priceCalc} equipmentData={equipmentData} />
      <Divider />
      <TradeInSection quote={quote} equipmentData={equipmentData} />
      <Divider />
      <AdditionalChargesSection quote={quote} />
      <Divider />
    </Stack>
  );
};
